<template>
    <div class="sm:items-start my-4">
        <span class="block text-lg font-medium text-zinc-800 sm:mt-2 sm:pt-2">
            Subject Matter Expertise
        </span>

        <div class="mt-2 w-3/4">
            <fieldset class="grid md:grid-cols-2">
                <legend class="sr-only text-black">
                    <span class="">
                        Subjects
                    </span>
                </legend>

                <div v-for="subject in allSubjects.slice(0,showAll ? 1000 : 10)">
                    <label class="font-medium text-gray-700 text-lg inline-block">
                        <input v-model="subjects" type="checkbox" :value="subject.id"
                            class="focus:ring-[#546FA3] h-4 w-4 text-[#546FA3] border-[#49454F] align-middle border rounded-sm">
                        <span class="align-middle ml-2">{{ subject.name }}</span>
                    </label>

                </div>
                <div>
                    <button v-if="!showAll" @click="showAll = true" class="underline">Show all</button>
                    <button v-else @click="showAll = false" class="underline">Show less</button>
                </div>
            </fieldset>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    props:{
        modelValue : Array
    },
    data(){
        return {
            allSubjects: [],
            showAll : false
        }
    },
    methods:{
        async load(){
            let data = await axios.get(route('profile.subjects.get')).then(resp => resp.data)
            this.allSubjects = data.subjects
        }
    },
    computed:{
        subjects:{
            get(){
                return this.modelValue
            },
            set(value){
                this.$emit('update:modelValue', value)
            }
        }

    },
    async mounted(){
        await this.load();
    },
    setup(){
        return {
            
        }
    }
}
</script>
